import { Component, createPlatform, OnInit, OnDestroy } from "@angular/core";
import { AdminFeaturesService } from "../../service/admin-features.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfirmationService, SelectItem } from "primeng/api";
import { IssoUtilService } from "src/app/services/isso-util.service";
import { MessageService } from "primeng/api";
import { AdminStudentProfileService } from "../../service/admin-student-profile.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-search-student-profile",
  templateUrl: "./search-student-profile.component.html",
  styleUrls: ["./search-student-profile.component.css"],
  providers: [MessageService, ConfirmationService],
})
export class SearchStudentProfileComponent implements OnDestroy, OnInit {
  private destroy$ = new Subject<void>();
  yearOptions: SelectItem[];
  display: boolean = false;
  editDialog: boolean = false;
  selectedStudent: any = null;
  editStudentProfile: any = null;

  isDataAvailble: boolean;
  schoolData: any;
  studentProfileData: any;
  studentDataLength: number = 0;
  schoolReadable: boolean;
  approvalCount = 0;
  pendingCount = 0;
  yearvalue: any;
  schoolName: any;
  schoolId: any;
  imagePreview: string | ArrayBuffer | null = null;
  /**
   * The photo already on file, as an upload-root path for `appAuthImg`.
   *
   * Kept apart from `imagePreview`, which after a file is chosen holds a data:
   * URL. /upload is behind the auth gate and a plain `[src]` carries no token,
   * so the stored photo has to be fetched, while the freshly picked one must not
   * be - one binding could not serve both.
   */
  storedPhotoPath: string | null = null;
  editStudentForm!: FormGroup;
  studentId: any;
  isLoading: boolean = false;
  setPhotoYear: string;
  serverUrl = environment.baseUrl;
  searchForm!: FormGroup;
  studentData: any = null;
  searchResult: any;
  searchResultData: any;
  showSearchResult: boolean;
  noSearchData: boolean;
  showDetails: boolean = false;
  activeTab: string = "profile";
  baseUrl: string;
  activeIndex: number = 0;
  title = "👤 Welcome to Profile";
  oldPhoto: any;
  standardClass: { label: string; value: string }[];
  curriculum: { label: string; value: string }[];
  tShirtSize: { label: string; value: string }[];
  fileError: string;
  uploadedFile: null;
  selectedFile: any;
  isMoreDot: boolean;
  fileName: number;
  fullFilename: string;
  studentUniqueId: any;
  studentProfileYearWiseData: any[];
  selectedYear: any;
  constructor(
    private issoUtilService: IssoUtilService,
    private messageService: MessageService,
    private confirmation: ConfirmationService,
    private fb: FormBuilder,
    private adminStudentProfileService: AdminStudentProfileService,
    private adminFeatures: AdminFeaturesService,
  ) {}

  ngOnInit() {
    this.baseUrl = environment.baseUrl;
    this.yearOptions = this.issoUtilService.studentProfileYear();
    this.searchForm = this.fb.group({
      searchQuery: ["", Validators.required],
    });
    this.setPhotoPath();
    this.tShirtSize = this.issoUtilService.setTshirtSize();
    this.standardClass = this.issoUtilService.setClass();
    this.curriculum = this.issoUtilService.setCurriculum();
  }

  beforeTabChange(index: number) {
    // if ((index === 1 || index === 2) && !this.yearvalue) {
    //   alert("Please select a year before accessing this tab.");
    //   return; // block change
    // }
    // console.log("after");

    this.activeIndex = index;
    if (index === 0) this.title = "👤 Welcome to Profile";
    else if (index === 1) this.title = "📅 Welcome to Event Details";
    else if (index === 2) this.title = "🏆 Welcome to Certificate";
  }
  // onTabChange(e: any) {
  //   // if (this.yearvalue !== undefined) {
  //   //   this.activeIndex = e.index;
  //   // } else {
  //   //   alert("please select Year");
  //   // }
  //   const requestedTab = e.index;
  //   if (!this.yearvalue && requestedTab > 0) {
  //     console.log("im if");
  //     alert("Please select a year before accessing this tab.");
  //     // Reset to Profile tab
  //     this.activeIndex = 0;
  //     return;
  //   } else {
  //     this.activeIndex = requestedTab;
  //   }
  // }

  viewDetails(student: any) {
    // this.display = true;
    this.showDetails = true;
    this.selectedStudent = student;
    this.yearvalue = "";
    this.selectedYear = "";
    this.loadTransferHistory();
  }

  /**
   * Every school this child has been at, and any move still in progress.
   *
   * Keyed on the ISSO id rather than the profile row, because that is the one
   * thing a transfer never changes - so the list stays complete no matter how
   * many times they have moved.
   */
  transferHistory: any[] = [];
  /** Every request, completed or not - the open-request guard reads this. */
  allTransfers: any[] = [];
  loadTransferHistory() {
    this.transferHistory = []; this.allTransfers = [];
    const uid = this.selectedStudent && this.selectedStudent.studentUniqueId;
    if (!uid) { return; }
    this.adminFeatures.transfersForStudent(uid)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        // Completed only: this tab is the record of where the student HAS been,
        // not a queue. A request still in flight, refused or withdrawn moved
        // nobody, and belongs on Transfer Requests where it can be acted on.
        (r: any[]) => {
          this.allTransfers = r || [];
          this.transferHistory = this.allTransfers.filter(t => t.status === "completed");
        },
        () => { this.transferHistory = []; this.allTransfers = []; },
      );
  }

  // ── Raise a transfer ────────────────────────────────────────────────────────
  // ISSO raising one on a family's behalf. It goes straight to the receiving
  // school, which is the only party that approves - the school the student is
  // leaving has no say and is told once it completes.
  raiseOpen = false;
  raiseQuery = "";
  raiseResults: any[] = [];
  raisePicked: any = null;
  raiseReason = "";
  raiseAdmission = "";
  raiseBusy = false;
  private raiseTimer: any = null;

  openRaise() {
    this.raiseOpen = true;
    this.raiseQuery = ""; this.raiseResults = []; this.raisePicked = null;
    this.raiseReason = ""; this.raiseAdmission = "";
  }
  closeRaise() { this.raiseOpen = false; }

  searchSchools() {
    const q = (this.raiseQuery || "").trim();
    if (this.raiseTimer) { clearTimeout(this.raiseTimer); }
    if (q.length < 2) { this.raiseResults = []; return; }
    this.raiseTimer = setTimeout(() => {
      this.adminFeatures.searchSchoolsPublic(q)
        .pipe(takeUntil(this.destroy$))
        .subscribe((r: any[]) => { this.raiseResults = r || []; }, () => { this.raiseResults = []; });
    }, 250);
  }

  pickSchool(s: any) { this.raisePicked = s; this.raiseResults = []; }

  /** Any live request blocks a new one - only one per student at a time. */
  get hasOpenTransfer(): boolean {
    return (this.allTransfers || []).some((t: any) => t.status === "pending_new_school");
  }

  submitRaise() {
    if (!this.raisePicked || !this.selectedStudent) { return; }
    this.raiseBusy = true;
    this.adminFeatures.raiseTransfer({
      studentProfileId: this.selectedStudent.sId,
      toSchoolId:       this.raisePicked.id,
      reason:           this.raiseReason.trim() || undefined,
      admissionNumber:  this.raiseAdmission.trim() || undefined,
    }).pipe(takeUntil(this.destroy$)).subscribe(
      () => {
        this.raiseBusy = false;
        this.raiseOpen = false;
        this.messageService.add({ key: "custom", severity: "success", summary: "Transfer request sent to the new school" });
        this.loadTransferHistory();
      },
      (e: any) => {
        this.raiseBusy = false;
        // key + life: the only <p-toast> on this screen is key="custom", so an
        // error raised without it rendered nowhere - a refusal the server had
        // explained in full showed up as a bare 409 in the console and nothing
        // on screen. These messages say what to do, so give them time to read.
        const detail = (e && e.error && e.error.error) || (e && e.errorDesc) || "Please try again.";
        this.messageService.add({
          key: "custom", severity: "error", life: 12000,
          summary: "Could not raise the transfer", detail,
        });
      },
    );
  }

  transferDate(t: any): string {
    const iso = t.appliedAt || t.requestedAt;
    if (!iso) { return "-"; }
    const d = new Date(iso);
    return isNaN(d.getTime()) ? "-" : d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  }
  searchStudent() {
    this.showDetails = false;
    this.isLoading = true;
    const query = this.searchForm.value.searchQuery;
    const formData = new FormData();

    formData.append("search_text", query);
    this.adminStudentProfileService.loadGloablStudentData(formData).pipe(takeUntil(this.destroy$)).subscribe(
      (response) => {
        if (response !== "") {
          this.isLoading = false;
          this.searchResult = response;
          this.searchResultData = this.searchResult;
          if (this.searchResultData.length > 0) {
            this.showSearchResult = true;
            this.noSearchData = false;
          } else {
            this.noSearchData = true;
          }
        } else {
        }
      },
      (error) => {
        this.isLoading = false;
        this.messageService.add({
          key: "custom",
          severity: "error",
          summary: error.errorDesc,
        });
      }
    );
    // const apiUrl = `https://your-api-url.com/api/students/search?query=${query}`;

    // this.http.get(apiUrl).pipe(takeUntil(this.destroy$)).subscribe(
    //   (response) => {
    //     this.studentData = response;
    //   },
    //   (error) => {
    //     console.error('Search failed', error);
    //     this.studentData = null;
    //   }
    // );
  }
  isValidSubGame(value: string | null): boolean {
    return !!value && value !== "undefined" && value.trim() !== "";
  }
  setPhotoPath() {
    let photoPath = this.yearvalue;
    this.setPhotoYear = this.serverUrl + "upload/" + photoPath;
  }
  // getFilteredSubgames(subGameString: string): string[] {
  //   if (!subGameString) return [];
  //   return subGameString
  //     .split(",")
  //     .map((s) => s.trim())
  //     .filter((s) => s.length > 0);
  // }

  getFilteredSubgames(value: string | null): string[] {
    if (!this.isValidSubGame(value)) {
      return [];
    }
    return value.split(",").map((v) => v.trim());
  }

  onYearChange(event) {
    //  this.isLoading = true;
    this.yearvalue = event.value;
    this.selectedYear = this.yearvalue;
    this.setPhotoPath();
    this.getStudentYearWiseProfile();
    if (this.yearvalue) {
      this.adminStudentProfileService
        .getStudentDataForCertificate(
          this.yearvalue,
          this.selectedStudent.studentUniqueId
        )
        .pipe(takeUntil(this.destroy$)).subscribe(
          (response: any[]) => {
            this.isLoading = false;
            this.studentProfileData = response;
            this.studentDataLength = Object.keys(
              this.studentProfileData
            ).length;
          },
          (error) => {
            this.isLoading = false;
            this.messageService.add({
              key: "custom",
              severity: "error",
              summary: error.errorDesc,
            });
          }
        );
    }
  }
  getStudentYearWiseProfile() {
    if (this.yearvalue) {
      this.adminStudentProfileService
        .getStudentYearWiseProfile(
          this.yearvalue,
          this.selectedStudent.studentUniqueId
        )
        .pipe(takeUntil(this.destroy$)).subscribe(
          (response: any[]) => {
            this.studentProfileYearWiseData = response[0];
            // this.isLoading = false;
            // this.studentProfileData = response;
            // this.studentDataLength = Object.keys(
            //   this.studentProfileData
            // ).length;
          },
          (error) => {
            this.isLoading = false;
            this.messageService.add({
              key: "custom",
              severity: "error",
              summary: error.errorDesc,
            });
          }
        );
    }
  }
  hasSubgames(student: any): boolean {
    return this.getSubgameKeys(student).length > 0;
  }
  getSubgameKeys(student: any): string[] {
    return Object.keys(student).filter((key) => !isNaN(Number(key)));
  }

  onSchoolChange(event) {
    this.schoolId = event.value;
    this.schoolName = event.originalEvent.currentTarget.ariaLabel;
  }

  onImageError(event: any) {
    event.target.src = "assets/images/default-user.png";
  }
  get f() {
    return this.editStudentForm.controls;
  }
  editStudent(student: any) {
    this.issoUtilService.getAcademicYearForPhoto();
    this.editDialog = true;

    this.editStudentProfile = student;
    this.studentId = student.sId;
    this.studentUniqueId = student.studentUniqueId;
    this.storedPhotoPath = student.photo ? this.setPhotoYear + "/" + student.photo : null;
    this.imagePreview = null;
    this.oldPhoto = student.photo;
    /**
     * Only the five fields this dialog actually SHOWS are required.
     *
     * The identity controls below are carried so the posted payload keeps its
     * shape, but the form never renders them - and `onSubmit` is wrapped in
     * `if (this.editStudentForm.valid)`. So a student with no contact number or
     * no aadhaar on file failed validation against a field nobody could see, and
     * saving their class or photo did nothing at all, with no error shown.
     */
    this.editStudentForm = this.fb.group({
      studentName: [this.editStudentProfile.studentName],
      fatherName: [this.editStudentProfile.fatherName],
      dateOfBirth: [this.editStudentProfile.dateOfBirth],
      contactNo: [this.editStudentProfile.contactNo],
      aadharNumber: [this.editStudentProfile.aadharNumber],
      admissionNumber: [
        this.editStudentProfile.admissionNumber,
        Validators.required,
      ],
      curruclm: [this.editStudentProfile.curruclm, Validators.required],
      standardClass: [
        this.editStudentProfile.standardClass,
        Validators.required,
      ],
      photo: [null],
      tShirtSize: [this.editStudentProfile.tShirtSize, Validators.required],
      gender: [this.editStudentProfile.gender],
    });
  }
  onFileSelect(event: any) {
    this.fileError = "";
    this.imagePreview = null;
    this.storedPhotoPath = null;
    this.uploadedFile = null;
    const file = event.target.files[0]; //event.files[0];
    if (file) {
      this.selectedFile = file;
    }
    var newName = event.target.files[0].name.split(".").slice(0, -1).join(".");
    if (newName.indexOf(".") !== -1) {
      this.isMoreDot = true;
    } else {
      this.isMoreDot = false;
    }
    if (file) {
      const validTypes = [
        "image/png",
        "image/jpeg",
        "image/JPEG",
        "image/jpg",
        "image/JPG",
        "image/PNG",
      ];
      if (!validTypes.includes(file.type) && !this.isMoreDot) {
        this.fileError = "File type not supported.";
        return;
      }
      // Same 2 MB ceiling as the Student grid and the backend.
      if (file.size > 2 * 1024 * 1024) {
        this.fileError = "File size must be below 2 MB.";
        return;
      }

      this.fileError = "";
      const reader = new FileReader();
      reader.onload = () => (this.imagePreview = reader.result);
      reader.readAsDataURL(file);

      var removeSpace = newName.replace(/\s/g, "");
      var ext = event.target.files[0].name.split(".").pop();
      this.fileName = Math.floor(Math.random() * 1000000000 + 1);
      this.fullFilename = removeSpace + this.fileName + "." + ext;
      this.editStudentForm.patchValue({ photo: file });
      this.uploadedFile = file;
    }
  }
  onSubmit() {
    this.isLoading = true;
    if (this.editStudentForm.valid) {
      const formData = new FormData();
      const updatedStudentData = this.editStudentForm.value;
      Object.keys(this.editStudentForm.controls).forEach((key) => {
        //formData.append(key, this.studentForm.get(key)?.value);
        const control = this.editStudentForm.get(key);
        formData.append(key, control ? control.value : "");
      });
      formData.append("studentId", this.studentId);
      formData.append("selectedYear", this.yearvalue);
      formData.append("studentUniqueId", this.studentUniqueId);
      const control = this.editStudentForm.get("photo");
      if (control && control.value) {
        const file = control.value;
      }
      if (this.selectedFile) {
        formData.append("profile", this.fullFilename);
        formData.append(
          "profile",
          this.editStudentForm.get("photo").value,
          this.fullFilename
        );
      } else {
        formData.append("profile", this.fullFilename);
        formData.append("profile", this.oldPhoto); // Send old file name to backend
      }

      this.adminStudentProfileService
        .updateStudentDataYearWise(formData)
        .pipe(takeUntil(this.destroy$)).subscribe(
          (res) => {
            this.isLoading = false;
            this.editDialog = false;
            if (res.status === "error") {
              this.messageService.add({
                key: "custom",
                severity: "error",
                summary: "Error Message",
                detail: "Validation failed",
              });
            } else {
              this.messageService.add({
                key: "custom",
                severity: "success",
                summary: "Data Updated Successfully",
              });
              this.getStudentYearWiseProfile();
            }
          },

          (error) => {
            this.isLoading = false;
            this.messageService.add({
              key: "custom",
              severity: "error",
              summary: error.errorDesc,
            });
          }
        );
    } else {
      this.editStudentForm.markAllAsTouched();
    }
    this.selectedFile = "";
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
